export default __webpack_public_path__ + "static/media/competitividade.dcb0af3b.svg";